import * as React from 'react';

/**
 * Source: [Codepen](https://codepen.io/cojdev/pen/jZErme)
 *
 * SVG Arrows
 *
 * @param props
 *      @property type: "down" | "up" | "right" | "left"
 */

const Arrow: React.SFC<{
    type: 'down' | 'up' | 'right' | 'left';
    width?: number;
    stroke?: string;
}> = ({ type, width, stroke }) => {
    stroke = stroke || '#333';
    width = width || 12;
    if (type === 'left') {
        return (
            <svg
                className="arrows"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                stroke={stroke}
                viewBox="0 0 40 40"
            >
                <polyline strokeLinejoin="miter" points="28,4 12,20 28,36" />
            </svg>
        );
    }
    if (type === 'right') {
        return (
            <svg
                className="arrows"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                viewBox="0 0 40 40"
                stroke={stroke}
            >
                <polyline strokeLinejoin="miter" points="12,4 28,20 12,36" />
            </svg>
        );
    }
    if (type === 'up') {
        return (
            <svg
                className="arrows"
                version="1.1"
                baseProfile="full"
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={width}
                viewBox="0 0 40 40"
                stroke={stroke}
            >
                <polyline strokeLinejoin="miter" points="4,28 20,12 36,28" />
            </svg>
        );
    }
    if (type === 'down') {
        return <i className="nx nx-arrow-d"></i>;
    }
};

export default Arrow;
